export default [
	{
		type: "uni",
		id: 1,
		title: "Evaluation des Lern-Management-Systems (LMS; z.B. Moodle, MS Teams, o.ä.)",
		items: [
			{
				id: 1,
				text: "Das LMS ist übersichtlich gestaltet.",
			},
			{
				id: 2,
				text: "Insgesamt bin ich der Meinung, dass das LMS die Qualität der Lehre positiv beeinflusst.",
			},
			{
				id: 3,
				text: "Mit Hilfe des LMSs konnte ich den Lernstoff leichter verinnerlichen.",
			},
			{
				id: 4,
				text: "Durch die Angebote auf dem LMS wurde mein Interesse am Thema der Veranstaltung gestärkt.",
			},
			{
				id: 5,
				text: "Mit dem LMS konnte ich mich über den Rahmen der Veranstaltung hinweg vertieft mit den Themen beschäftigen.",
			},
			{
				id: 6,
				text: "Der Umgang mit dem LMS trug zum Verständnis der Inhalte bei.",
			},
			{
				id: 7,
				text: "Die Qualität der auf dem LMS zur Verfügung gestellten Inhalte war gut.",
			},
			{
				id: 8,
				text: "Die im Rahmen von Online-Aktivitäten zu bearbeitenden Materialien waren für das LMS geeignet.",
			},
			{
				id: 9,
				text: "Die Inhalte der online zu bearbeitenden Materialien wurde ausreichend vorbereitet.",
			},
			{
				id: 10,
				text: "Insgesamt habe ich durch die Kombination von Präsenzterminen und Online-Aktivitäten mehr gelernt.",
			},
			{
				id: 11,
				text: "Die Online-Aktivitäten in dieser Lehrveranstaltung waren mit eindeutigen Aufgaben und Zielen verbunden.",
			},
			{
				id: 12,
				text: "Während der Online-Aktivitäten habe ich mich gut betreut gefühlt.",
			},
			{
				id: 13,
				text: "Ich hätte mehr gelernt, wenn die online bearbeiteten Themen und Aufgaben im Rahmen von Präsenzterminen behandelt worden wären.",
			},
		],
	},
];
